module.exports = __webpack_public_path__ + "img/next-arrow.ea0caab1.svg";